module.exports = __webpack_public_path__ + "f4ffee8b31f07a13bd21f5db455f3663.jpg";